import Image from 'next/image';

import { Banner, Col, Typography, Row } from 'darrius';

import { imgPrefix } from '../../../../utils/imgPrefix';

import { type TDialogInternalLoadingProps } from './@interfaces';

export function DialogInternalLoading({ title }: TDialogInternalLoadingProps) {
  return (
    <Row className="center-sm">
      <Col className="col-sm-12">
        <Image
          src={imgPrefix('/images/get-ninjas-spinner.gif')}
          alt="Um spinner de carregamento"
          title="Um spinner de carregamento"
          height={77}
          width={77}
        />
        <Banner>
          <Typography.Title as="h3" size="3xl">
            {title}
          </Typography.Title>
        </Banner>
      </Col>
    </Row>
  );
}
